import React, { Fragment, useEffect, useState, useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import PageNotFound from "../PageNotFound";
import Logout from "../auth/Logout";
import Sidebar from "../layout/Sidebar";
import axios from "axios";
import { UsersHeader, UsersData } from "../ContextAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faHome,
  faThumbsUp,
  faUserLock,
} from "@fortawesome/free-solid-svg-icons";
import OMDashboard from "src/om/OMDashboard";
import LeaveForm from "src/om/leave/LeaveForm";
import Account from "src/om/account/Account";
import LeaveForApproval from "src/om/for-approval/LeaveForApproval";

const RouteOM = () => {
  const [sidebarHeader, setSidebarHeader] = useState([]);
  const userContext = useContext(UsersData);

  const getSidebarHeaderInfo = async () => {
    try {
      var params = { user_id: userContext.users.user_id };
      const response = await axios.get("om/sidebar/header-infomartion", {
        params,
      });
      setSidebarHeader(response.data);
    } catch (error) {
      console.log("Unable to get sidebar header info.", error);
    }
  };

  const sidebarRoute = [
    {
      name: "Dashboard",
      show: true,
      icon: <FontAwesomeIcon icon={faHome} color="white" size={"2x"} />,
      path: "/sph/app/operation-manager",
      subitem: [],
    },
    {
      name: "Leave Application",
      show: true,
      icon: <FontAwesomeIcon icon={faAddressCard} color="white" size={"2x"} />,
      path: "/sph/app/operation-manager/leave-application",
      subitem: [],
    },
    {
      name: "Leave For Approval",
      show: true,
      icon: <FontAwesomeIcon icon={faThumbsUp} color="white" size={"2x"} />,
      path: "/sph/app/operation-manager/leave-approval",
      subitem: [],
    },
    {
      name: "Account",
      show: true,
      icon: <FontAwesomeIcon icon={faUserLock} color="white" size={"2x"} />,
      path: "/sph/app/operation-manager/account",
      subitem: [],
    },
  ];

  const handleRenderInfo = () => {
    getSidebarHeaderInfo();
  };

  useEffect(() => {
    getSidebarHeaderInfo();
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <UsersHeader.Provider
        value={{
          sidebarHeader: sidebarHeader,
          renderPharmacyInfo: handleRenderInfo,
        }}
      >
        <BrowserRouter>
          <Sidebar
            notification={{
              enable: true,
              owner: "om",
            }}
            header={sidebarHeader}
            routes={sidebarRoute}
            module={"om"}
          />
          <Switch>
            <Route
              exact
              path="/"
              component={() => <Redirect to="/sph/app/operation-manager" />}
            />
            <Route
              exact
              path="/bmcdc"
              component={() => <Redirect to="/sph/app/operation-manager" />}
            />
            <Route
              exact
              path="/sph/app"
              component={() => <Redirect to="/sph/app/operation-manager" />}
            />
            <Route
              exact
              path="/sph/app/operation-manager"
              component={OMDashboard}
            />

            <Route
              exact
              path="/sph/app/operation-manager/leave-application"
              component={LeaveForm}
            />

            <Route
              exact
              path="/sph/app/operation-manager/leave-approval"
              component={LeaveForApproval}
            />

            <Route
              exact
              path="/sph/app/operation-manager/account"
              component={Account}
            />
            <Route exact path="/sph/app/logout" component={Logout} />

            <Route render={() => <PageNotFound title="Page not found" />} />
          </Switch>
        </BrowserRouter>
      </UsersHeader.Provider>
    </Fragment>
  );
};

export default RouteOM;
